<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>老师考勤</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="4">
            <FormItem label="老师：">
              <el-input name="tchId"
                        v-model="queryParam.tchKey" placeholder="ID/昵称" clearable></el-input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="情况说明：">
              <el-input name="tchId"
                        v-model="queryParam.remark" placeholder="" clearable></el-input>
            </FormItem>
          </Col>
          <i-col :span="4">
            <Form-item label="外教运营">
              <Select v-model.number="queryParam.studyAdviserId" placeholder="全部"
                      @on-change="search" clearable>
                <Option v-for="item in studyAdviserList"
                        :value="item.id" :key="item.id">{{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="添加时间：">
              <Row>
                <Col :span="11">
                  <Date-picker type="month" format="yyyy-MM" placeholder="请选择日期"
                               @on-change="startTimeDateChange"
                               v-model="startDateSelected" style="width: 100%;"></Date-picker>
                </Col>
                <Col :span="1" style="text-align: center">-</Col>
                <Col :span="11">
                  <Date-picker type="month" format="yyyy-MM" placeholder="请选择日期"
                               @on-change="endTimeDateChange"
                               v-model="endDateSelected" style="width: 100%;"></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </i-col>
          >
        </Row>
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="4">
            <el-button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                       @click="search">搜索
            </el-button>
            <el-button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                       @click="exportData">导出
            </el-button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/tch/lesson/attendance-list"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
    <ModifyAttendanceScoreModal :successCallback="search" @on-close="closeComplaintModal" :complaintRow="this.complaintRow"
                          :visible="showUpdateScoreModal"></ModifyAttendanceScoreModal>
  </div>
</template>
<script>
import ShowImageCarousel from '../order/ShowImageCarousel'
import ModifyAttendanceScoreModal from './modal/ModifyAttendanceScoreModal'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  components: {ShowImageCarousel, ModifyAttendanceScoreModal},
  data() {
    let $constant = this.$constant
    return {
      complaintRemarkList: $constant.tchComplaintRemark,
      searchLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      showImgModal: false,
      complaintRow: null,
      showUpdateScoreModal: false,
      showImgList: [],
      studyAdviserList: [],
      startDateSelected: this.getCurrentMonth(),
      endDateSelected: this.getCurrentMonth(),
      queryParam: {
        tchKey: null,
        remark: null,
        startDate: this.getCurrentMonth(),
        endDate: this.getCurrentMonth(),
        studyAdviserId: null
      },
      title: [
        {
          title: '月份',
          width: 130,
          key: 'createMonth',
        },
        {
          title: '老师ID',
          width: 150,
          key: 'tchId',
        },
        {
          title: '老师姓名',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchName,
              score: row.monthRankScore
            })
          }
        },
        {
          title: '外管打分',
          width: 150,
          align: 'center',
          key: 'adminScore'
        },
        {
          title: '出勤分数',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.goToAttendanceDetail(params.row)
                  }
                }
              }, params.row.score)
            ])
          }
        },
        {
          title: '总分',
          width: 150,
          align: 'center',
          key: 'totalScore',
        },
        {
          title: '操作',
          align: 'center',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.onUpdateComplaint(params.row)
                  }
                }
              }, '打分')
            ])
          }
        }
      ]
    }
  },
  mounted: function () {
    let self = this
    this.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then(function (res) {
      if (!res || !res.data) {
        return
      }
      self.studyAdviserList = res.data
    })
  },
  created: function () {
  },
  methods: {
    search() {
      this.reload = new Date().getTime()
    },
    onLoading(loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },
    openInfoModal(val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserPayList'}
      })
      window.open(href, '_blank')
    },
    viewPic(row) {
      this.showImgList = row.pics
      this.showImgModal = true
    },
    closeImgModal() {
      this.showImgList = []
      this.showImgModal = false
    },
    closeComplaintModal(val) {
      this.showUpdateScoreModal = false
      this.complaintRow = {}
    },

    onUpdateComplaint(row) {
      this.showUpdateScoreModal = true
      this.complaintRow = row
    },
    exportData(type) {
      this.exportLoading = true
      this.$http.get('/tch/lesson/attendance-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '老师月度考勤.xlsx'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    startTimeDateChange(value) {
      this.queryParam.startDate = value
    },
    endTimeDateChange(value) {
      this.queryParam.endDate = value
    },
    getCurrentMonth() {
      const date = new Date()
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      return `${year}-${month < 10 ? '0' + month : month}`
    },
    goToAttendanceDetail (row) {
      this.$router.push({
        path: '/tch/tchAttendanceDetailList',
        query: {
          tchId: row.tchId,
          startDate: row.createMonth,
          endDate: row.createMonth
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// TchAttendanceList.vue?0f199bbf